import React from "react";
import LoadingComponent from "./LoadingComponent";
import {GenericDialog, GenericDialogActions, GenericGrid, GenericLabel, GenericTextInput} from "./Generic";
import {DialogContent, DialogTitle} from "@material-ui/core";
import PropTypes from "prop-types";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import Button from "../../components/CustomButtons/Button";
import {Proxy} from "../../core";
import GridButton from "./GridButton";
import {ApproveIcon} from "../../core/Icons";


class SearchDialog extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            formValues: this.initializeValues(),
            isOpened: false,
            isLoading: false,
            results: []
        };

    }

    initializeValues = () => {
        const { Inputs } = this.props;
        if (Inputs == null) return;

        const values = {};
        Inputs.forEach((input) => {
            values[input.name] = "";
        });
        return values;
    }

    handleOpen = () => {
        this.setState({
            isOpened: true
        });
    }

    handleClose = () => {
        this.setState({
            formValues: this.initializeValues(),
            isOpened: false,
            results: []
        });
    }

    handleSearch = () => {
        const { formValues } = this.state;
        const { SearchUrl, Parameters } = this.props;

        this.setState({ isLoading: true });

        Proxy.POST(SearchUrl, { ...formValues, ...Parameters }, this.onSuccess, this.onError);
    }

    onSuccess = (responseData) => {
        if (responseData.Item != null) {
            this.setState({
                results: responseData.Item,
                isLoading: false
            });
        }
        else {
            this.setState({
                results: [],
                isLoading: false
            });
        }
    }

    onError = () => {
        this.setState({ isLoading: false });
    }

    handleInputChange = (name, value) => {
        this.setState((prevState) => ({
            formValues: {
                ...prevState.formValues,
                [name]: value.trim()
            },
        }));
    }

    handleSelect = (model, _) => {
        const { OnSelect, Name } = this.props;

        OnSelect(Name, model.Id, model);

        this.handleClose();
    }

    getColumns = () => {
        const { Columns } = this.props;

        return [
            {
                Header: "Select",
                accessor: "Select",
                Cell: row => (
                    <div>
                        <GridButton
                            tooltip="Select"
                            Icon={ApproveIcon}
                            OnClick={() => { this.handleSelect(row.original, row.index); }} />
                    </div>
                ),
                sortable: false,
                filterable: false,
                width: 60
            },
            ...Columns
        ];
    }

    render() {
        const { Title, Description, Inputs, IsDisabled } = this.props;
        const { isOpened, isLoading, formValues, results } = this.state;

        return (
            <>
                <LoadingComponent Show={isLoading} />

                <Button
                    size="sm"
                    justIcon
                    disabled={IsDisabled}
                    onClick={this.handleOpen}
                >
                    <i className="fas fa-search" />
                </Button>

                <GenericDialog
                    open={isOpened}
                    maxWidth="md"
                    fullWidth
                    keepMounted
                >
                    <DialogTitle>
                        <GenericLabel
                            FontSize="16px"
                            Text={Title}
                            Bold
                        />
                        {
                            Description ?
                                <>
                                    <br/>
                                    <GenericLabel
                                        FontSize="12px"
                                        Text={Description}
                                    />
                                </>
                                : ""
                        }
                    </DialogTitle>

                    <DialogContent style={{ marginTop: 8 }} >
                        <GridContainer>
                            {
                                Inputs != null && Inputs.length > 0 ? Inputs.map((input, index) => (
                                        <GridItem key={index} xs={6}>
                                            <GenericTextInput
                                                Name={input.name}
                                                LabelText={input.label}
                                                Value={formValues[input.name]}
                                                ValueChanged={this.handleInputChange}
                                            />
                                        </GridItem>
                                    ))
                                    : ""
                            }
                        </GridContainer>
                        <GridContainer>
                            <GridItem xs={12}>
                                <br />
                                <GenericGrid
                                    PageSize={10}
                                    Data={results}
                                    Columns={this.getColumns()}
                                    RowSelected={this.RowSelected}
                                    SelectedIndex={this.state.selected}
                                    HideButton={true}
                                    ShowPagination={true} />
                            </GridItem>
                        </GridContainer>
                    </DialogContent>
                    <GenericDialogActions>
                        <Button
                            size="sm"
                            onClick={this.handleSearch}
                        >
                            Search
                        </Button>
                        <Button size="sm" onClick={this.handleClose}>Cancel</Button>
                    </GenericDialogActions>
                </GenericDialog>
            </>
        );
    }
}

SearchDialog.propTypes = {
    Title: PropTypes.string,
    Description: PropTypes.string,
    Inputs: PropTypes.array,
    Columns: PropTypes.array,
    IsDisabled: PropTypes.bool,
    SearchUrl: PropTypes.string,
    Parameters: PropTypes.any,
    OnSelect: PropTypes.func,
};

export default SearchDialog;